
import React from 'react';
import { flags, routes, userDropdownItemPropType } from 'constants';
import { useFeatureFlagState } from '../../../hooks/useFeatureFlagState';

const UserDropdownItem = ({ item }) => {
  const featureFlagState = useFeatureFlagState([flags.moonshotOutage]);
  const isMoonshotEnabled = featureFlagState[flags.moonshotOutage].isEnabled;
  const Component = typeof item.href === 'undefined' ? 'button' : 'a';

  return (
    <Component
      className="nx-current-user-dropdown-item"
      href={
        item.label === 'Billing' && isMoonshotEnabled
          ? routes.billingSummary
          : item.href
      }
      onClick={item.onClick}
    >
      {item.label}
    </Component>
  );
};

UserDropdownItem.propTypes = {
  item: userDropdownItemPropType,
};

export default UserDropdownItem;
